(() => {
  const initialize = (root) => {
    if (root.dataset.ceReady === 'true') return;
    root.dataset.ceReady = 'true';
    const panel = root.querySelector('[data-ce-panel]');
    const form = panel?.querySelector('form');
    if (!panel || !form) return;
    const storageKey = `chic-event-request:${location.pathname}:${form.id}`;
    const fields = [...form.querySelectorAll('input:not([type="hidden"]), select, textarea')];
    const readDraft = () => {
      try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!draft || !draft.values || Date.now() - draft.savedAt > 86400000) return;
        fields.forEach((field) => {
          if (typeof draft.values[field.name] === 'string') field.value = draft.values[field.name];
        });
      } catch (_) {}
    };
    const saveDraft = () => {
      try {
        const values = {};
        fields.forEach((field) => { values[field.name] = field.value; });
        sessionStorage.setItem(storageKey, JSON.stringify({ values, savedAt: Date.now() }));
      } catch (_) {}
    };
    const success = form.querySelector('[data-ce-success]');
    const submittedKey = `chic-event-last-submitted:${location.pathname}`;
    let lastSubmitted = '';
    try { lastSubmitted = sessionStorage.getItem(submittedKey) || ''; } catch (_) {}
    const returnedToThisForm = location.hash === `#${form.id}` || (!location.hash.includes('ChicEventForm-') && lastSubmitted === form.id);
    const returnedErrors = form.querySelector('[data-ce-errors]');
    if (returnedErrors && !returnedToThisForm) returnedErrors.hidden = true;
    if (success && returnedToThisForm) {
      form.querySelector('[data-ce-form-content]').hidden = true;
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      if (location.hash === `#${form.id}` || new URLSearchParams(location.search).get('contact_posted') === 'true') {
        success.focus({ preventScroll: true });
        panel.scrollIntoView({ block: 'center' });
      }
      return;
    }
    if (success) success.hidden = true;
    readDraft();
    const dates = [...form.querySelectorAll('[data-ce-date]')];
    const chicagoDate = () => {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const part = (type) => parts.find((entry) => entry.type === type).value;
      return `${part('year')}-${part('month')}-${part('day')}`;
    };
    const minimumDate = () => {
      const opening = /^\d{4}-\d{2}-\d{2}$/.test(root.dataset.openingDate || '') ? root.dataset.openingDate : '';
      const today = chicagoDate();
      return opening > today ? opening : today;
    };
    const updateValidity = () => {
      const min = minimumDate();
      dates.forEach((field) => {
        field.min = min;
        field.setCustomValidity(field.value && field.value < min ? root.dataset.dateError : '');
      });
      const guests = form.querySelector('[data-ce-guests]');
      const count = Number(guests.value);
      const validGuests = !guests.value || guests.value === 'custom' || (Number.isInteger(count) && count >= Number(root.dataset.minGuests) && count <= Number(root.dataset.maxGuests));
      guests.setCustomValidity(validGuests ? '' : root.dataset.guestError);
    };
    const updateEstimate = () => {
      const guests = form.querySelector('[data-ce-guests]');
      const activity = form.querySelector('[data-ce-activity]');
      const customGroup = guests.value === 'custom';
      const custom = customGroup || activity.value !== 'Jewelry making';
      const numeric = form.querySelector('[data-ce-numeric-estimate]');
      const quote = form.querySelector('[data-ce-custom-estimate]');
      numeric.hidden = custom;
      quote.hidden = !custom;
      form.querySelector('[data-ce-custom-copy]').textContent = customGroup ? root.dataset.customGroupCopy : root.dataset.customActivityCopy;
      const value = form.querySelector('[data-ce-estimate-value]');
      if (custom) {
        value.value = 'Tailored quote requested; no jewelry-only estimate applied';
        return;
      }
      const minimum = Number(root.dataset.minGuests);
      const count = Math.max(Number(guests.value) || minimum, minimum);
      const total = Math.round(Number(root.dataset.priceCents) * count);
      const deposit = Math.round(total * Number(root.dataset.depositPercent) / 100);
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format(cents / 100);
      form.querySelector('[data-ce-total]').textContent = money(total);
      form.querySelector('[data-ce-deposit]').textContent = money(deposit);
      form.querySelector('[data-ce-balance]').textContent = money(total - deposit);
      value.value = `USD ${(total / 100).toFixed(2)} group minimum; USD ${(deposit / 100).toFixed(2)} credited deposit; USD ${((total - deposit) / 100).toFixed(2)} remaining minimum; final written quote required`;
    };
    updateValidity();
    updateEstimate();
    form.addEventListener('input', () => { updateValidity(); updateEstimate(); saveDraft(); });
    form.addEventListener('change', () => { updateValidity(); updateEstimate(); saveDraft(); });
    const submit = form.querySelector('[data-ce-submit]');
    let submitting = false;
    let activeStep = 0;
    let dialog = null;
    let lastTrigger = null;
    let overflowBefore = '';
    const steps = [...form.querySelectorAll('[data-ce-step]')];
    const next = form.querySelector('[data-ce-next]');
    const back = form.querySelector('[data-ce-back]');
    const indicators = [...form.querySelectorAll('[data-ce-indicator]')];
    const summary = form.querySelector('[data-ce-summary]');
    const canEnhance = typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';
    const selectedText = (field) => field.tagName === 'SELECT' ? field.options[field.selectedIndex]?.textContent.trim() : field.value;
    const renderSummary = () => {
      summary.replaceChildren();
      [...form.querySelectorAll('[data-ce-summary-label]')].forEach((field) => {
        const row = document.createElement('div');
        const label = document.createElement('dt');
        const value = document.createElement('dd');
        label.textContent = field.dataset.ceSummaryLabel;
        let text = field.value ? selectedText(field) : root.dataset.emptyValue;
        if (field.value && field.type === 'date') {
          const [year, month, day] = field.value.split('-').map(Number);
          text = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { dateStyle: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(year, month - 1, day)));
        }
        value.textContent = text;
        row.append(label, value);
        summary.append(row);
      });
    };
    const showStep = (index, focus = true) => {
      activeStep = index;
      steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
      indicators.forEach((indicator, indicatorIndex) => {
        if (indicatorIndex === index) indicator.setAttribute('aria-current', 'step');
        else indicator.removeAttribute('aria-current');
      });
      back.hidden = index === 0;
      next.hidden = index === 2;
      submit.hidden = index !== 2;
      if (index === 2) renderSummary();
      if (focus) {
        steps[index].querySelector('legend').focus({ preventScroll: true });
        if (dialog) dialog.scrollTop = 0;
      }
    };
    const validateFields = (scope) => {
      updateValidity();
      const invalid = [...scope.querySelectorAll('input, select, textarea')].find((field) => !field.checkValidity());
      if (!invalid) return true;
      if (canEnhance) {
        const index = Number(invalid.closest('[data-ce-step]')?.dataset.ceStep || 0);
        showStep(index, false);
      }
      invalid.reportValidity();
      invalid.focus();
      return false;
    };
    const resetSubmit = () => {
      submitting = false;
      submit.disabled = false;
      submit.textContent = root.dataset.submitLabel;
      form.removeAttribute('aria-busy');
    };
    if (canEnhance) {
      dialog = document.createElement('dialog');
      dialog.className = 'ce-dialog';
      dialog.setAttribute('aria-labelledby', panel.querySelector('h2').id);
      root.append(dialog);
      dialog.append(panel);
      root.classList.add('ce-enhanced');
      form.noValidate = true;
      form.querySelector('[data-ce-steps]').hidden = false;
      panel.querySelector('[data-ce-close]').hidden = false;
      const close = () => { saveDraft(); dialog.close(); };
      const open = (trigger) => {
        lastTrigger = trigger || document.activeElement;
        updateValidity();
        if (!dialog.open) {
          overflowBefore = document.documentElement.style.overflow;
          dialog.showModal();
        }
        document.documentElement.style.overflow = 'hidden';
        if (returnedErrors && returnedToThisForm) {
          showStep(1, false);
          form.querySelector('[data-ce-errors]').focus();
        } else showStep(activeStep);
      };
      root.querySelectorAll('[data-ce-open]').forEach((trigger) => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', panel.id);
        trigger.addEventListener('click', (event) => { event.preventDefault(); open(trigger); });
      });
      panel.querySelector('[data-ce-close]').addEventListener('click', close);
      dialog.addEventListener('cancel', saveDraft);
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = overflowBefore;
        if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      next.addEventListener('click', () => {
        if (validateFields(steps[activeStep])) showStep(activeStep + 1);
      });
      back.addEventListener('click', () => showStep(Math.max(0, activeStep - 1)));
      form.querySelector('[data-ce-edit]').addEventListener('click', () => showStep(0));
      showStep(0, false);
      if ((returnedErrors && returnedToThisForm) || location.hash === `#${form.id}`) open(root.querySelector('[data-ce-open]'));
    }
    form.addEventListener('submit', (event) => {
      if (submitting) { event.preventDefault(); return; }
      if (canEnhance && activeStep < 2) {
        event.preventDefault();
        if (validateFields(steps[activeStep])) showStep(activeStep + 1);
        return;
      }
      if (!validateFields(form)) { event.preventDefault(); return; }
      saveDraft();
      try { sessionStorage.setItem(submittedKey, form.id); } catch (_) {}
      submitting = true;
      submit.disabled = true;
      submit.textContent = root.dataset.submitting;
      form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => { resetSubmit(); updateValidity(); updateEstimate(); });
    window.addEventListener('pagehide', saveDraft);
  };
  const initializeHub = (hub) => {
    if (hub.dataset.ceHubReady === 'true') return;
    hub.dataset.ceHubReady = 'true';
    const list = hub.querySelector('[data-ce-tabs]');
    const tabs = [...list.querySelectorAll('[data-ce-tab]')];
    const venues = [...hub.querySelectorAll('[data-ce-venue]')];
    list.setAttribute('role', 'tablist');
    const activate = (slug, focus = false) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.ceTab === slug;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      venues.forEach((venue) => { venue.hidden = venue.dataset.ceVenue !== slug; });
    };
    tabs.forEach((tab, index) => {
      const venue = venues.find((node) => node.dataset.ceVenue === tab.dataset.ceTab);
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', venue.id);
      venue.setAttribute('role', 'tabpanel');
      venue.setAttribute('aria-labelledby', tab.id);
      venue.tabIndex = 0;
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(tab.dataset.ceTab);
      });
      tab.addEventListener('keydown', (event) => {
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(tabs[next].dataset.ceTab, true);
      });
    });
    let returnedFormId = location.hash.slice(1);
    if (!returnedFormId && hub.querySelector('[data-ce-success],[data-ce-errors]')) {
      try { returnedFormId = sessionStorage.getItem(`chic-event-last-submitted:${location.pathname}`) || ''; } catch (_) {}
    }
    const requested = venues.find((venue) => location.hash === `#${venue.id}` || venue.querySelector('form')?.id === returnedFormId);
    activate(requested?.dataset.ceVenue || tabs[0].dataset.ceTab);
  };
  const boot = (scope) => {
    scope.querySelectorAll('[data-ce-hub]').forEach(initializeHub);
    scope.querySelectorAll('[data-chic-events]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
